import { useTranslation } from 'react-i18next'

import { ConfigurationSettingsTabId } from '../../../../../constants/configurationSettings'
import { useInitData } from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import { getConfigurationSettingsLinkProps } from '../../../../../utils/link'
import { Link } from '../../../../Link'
import Text from '../../../../Text'
import {
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_EMPTY,
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SETTINGS_LINK,
} from '../../../CalendarSettings.constants'

import * as styles from './TaskTypesFieldEmpty.module.css'

function TaskTypesFieldEmpty() {
  const { t } = useTranslation()

  const { availableSections } = useInitData()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_EMPTY })}
      className={styles.TaskTypesFieldEmpty}
    >
      <Text isSecondary>{t('CalendarSettings.NoTaskTypesKey')}</Text>
      <Link
        {...getQaSelector({
          value: QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SETTINGS_LINK,
        })}
        {...getConfigurationSettingsLinkProps({
          availableSections,
          tab: ConfigurationSettingsTabId.ActivityTypes,
        })}
      >
        {t('CalendarSettings.TaskTypesSettingsLinkKey')}
      </Link>
    </div>
  )
}

export default TaskTypesFieldEmpty
